import { useState } from "react"
import { Button, Modal } from "react-bootstrap"
import { FaRegUser } from "react-icons/fa6"
import BuscadorCodigo from "./buscador_codigo"
import { LuBox } from "react-icons/lu"

const ModalSeleccionProductos = (props) => {
    const {
        titulo
    } = props
    const title = titulo ? titulo : "SELECCIONAR PRODUCTO"
    const [ openModal, setOpenModal ] = useState(false)

    const handleClose = () => {
        setOpenModal(false)
    }

    const onSelect = (data) => {
        if(props.onSelect)  props.onSelect(data)
        handleClose()
    }

    const modalFiltro = () => {

        return <Modal show={openModal} size="lg" onHide={()=>handleClose()} centered >
            <Modal.Header closeButton>
            <Modal.Title>Filtrar</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <BuscadorCodigo showResults={true} tipo="funcion" onSelectProduct={(data) => onSelect(data)} />
            </Modal.Body>
      </Modal>
    }

    return <div>
        <Button size="sm" variant="light" className="mb-3" onClick={() => setOpenModal(true)}><LuBox /> {title}</Button>
        {modalFiltro()}
    </div>
}

export default ModalSeleccionProductos